import { render } from "./TemplateSettings.vue?vue&type=template&id=7fd0917a&ts=true"
import script from "./TemplateSettings.vue?vue&type=script&lang=ts"
export * from "./TemplateSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__